const calculateSuccessClass = (value: number, range = 10, reverse = false) => {
  const colorNumber = value / range;
  let output = 0;
  if (colorNumber >= 1) {
    output = 9;
  } else {
    output = +(colorNumber.toFixed(1) + '').split('.')[1][0];
  }

  if (reverse) {
    output = 9 - output;
  }
  return `success-${output}`;
}

export default {
  calculateSuccessClass
}